<template>
  <div id="app">

    <header-area :settings=settings></header-area>

    <main role="main">
      <router-view></router-view>
    </main>

    <footer-area class="d-print-none" :settings=settings></footer-area>
  </div>


  </div>
</template>


<script>
import AppFooter from '@/components/layout/AppFooter';
import AppHeader from '@/components/layout/AppHeader';

import { mapGetters, mapActions } from 'vuex';


export default {
    name: 'Generic',

    components: {
      FooterArea:AppFooter,
      HeaderArea:AppHeader,
    },

    created() {
      this.getOrCreateSetting();
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
      })
    },

    computed: {
      ...mapGetters('settings', {
        settings: 'settings'
      }),

    },
}

</script>


<style scoped>

.bg-dark2{
  background: linear-gradient(0deg, rgba(64,64,64,1) 0%, rgba(37,37,37,1) 100%);
}

header p {
  color: #fff;
}
.main_title{
  color: #fff!important;
  font-size: 16px;
  padding-top: 10px;
  display: inline-block;

}

.subtitle_heading {
  color: #00AFF0;
  font-family: 'Caveat Brush', cursive;
  font-size: 40px;
  margin-bottom: 0px;
}

.main_title.sm, .main_title.md {
  display: none;
}

</style>

<style>
@media only screen and (max-width: 768px) {
  footer {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Result.vue